import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getRecommendedActionTemplates } from '@api';

export const getCoreDataSecurityActionTemplatesSlice = createGetAsyncSlice({
	name: 'CoreDataSecurityActionTemplates',
	receive: true,
	request: false,
	requestHandler: getRecommendedActionTemplates
});
